import * as yup from 'yup';

export const loginSchema = yup.object().shape({
  email: yup.string().email('Lütfen geçerli bir e-posta giriniz.').required('Zorunlu Alan'),
  password: yup.string().min(6, 'Şifre en az 6 karekter olmalı.').max(16, 'Şifre en fazla 16 karekter olmalı.').required('Zorunlu Alan'),
});
